import { useGetList, useLocaleState } from 'react-admin';
import { localizedJsonText } from '../../utils/localizedJsonText';

const useCategories = () => {
  const [locale] = useLocaleState();
  const { data, isLoading, error } = useGetList('categories', {
    pagination: { page: 1, perPage: 100 },
    sort: { field: 'name', order: 'ASC' },
  });

  if (isLoading || error || !data) {
    return [];
  }

  return data.map((category) => ({
    id: category.id,
    label: localizedJsonText(category.name, locale, category.id),
  }));
};

export default useCategories;
